module.exports = __webpack_public_path__ + "static/media/lullascape-logo.c7b1e3f6.png";